module.exports = __webpack_public_path__ + "img/yAxis.e4608167.svg";